import { render, staticRenderFns } from "./redGrapeIcon.vue?vue&type=template&id=62168ca0&"
import script from "./redGrapeIcon.vue?vue&type=script&lang=js&"
export * from "./redGrapeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports